/**
 * IrrigationPlanHistory component
 * Displays the history tab with filters, summary, and timeline
 */

interface IrrigationPlanHistoryProps {
  /** Filters bar component */
  filtersBar: React.ReactNode;
  /** Summary cards component */
  summaryCards: React.ReactNode;
  /** Timeline component */
  timeline: React.ReactNode;
  /** Whether there are more history entries to load */
  hasMore: boolean;
  /** Whether history is loading */
  isLoading: boolean;
  /** Handler for loading more history entries */
  onLoadMore: () => void;
}

export function IrrigationPlanHistory({
  filtersBar,
  summaryCards,
  timeline,
  hasMore,
  isLoading,
  onLoadMore,
}: IrrigationPlanHistoryProps) {
  return (
    <div className="space-y-6">
      <section className="rounded-xl border border-neutral-200 bg-white p-5">
        <h2 className="text-base font-semibold text-gray-900">Controles de histórico</h2>
        <p className="mt-1 text-sm text-neutral-500">Ajuste escopo, filtros e intervalo de análise para este plano.</p>
        <div className="mt-4">{filtersBar}</div>
      </section>

      <section className="space-y-3">
        <div className="flex items-center justify-between">
          <h2 className="text-base font-semibold text-gray-900">Resumo</h2>
          <span className="text-xs uppercase tracking-wide text-gray-500">Dados agregados</span>
        </div>
        {summaryCards}
      </section>

      <section className="space-y-4 rounded-xl border border-neutral-200 bg-white p-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-base font-semibold text-gray-900">Linha do tempo de eventos</h2>
            <p className="text-sm text-gray-500">Eventos são exibidos em ordem decrescente de início.</p>
          </div>
        </div>
        {timeline}
        {hasMore ? (
          <div className="flex justify-center">
            <button
              type="button"
              onClick={onLoadMore}
              disabled={isLoading}
              className={`inline-flex items-center rounded-md px-4 py-2 text-sm font-semibold shadow focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                isLoading
                  ? "cursor-not-allowed border border-neutral-300 bg-neutral-100 text-neutral-500"
                  : "border border-blue-600 bg-blue-600 text-white hover:bg-blue-700"
              }`}
            >
              {isLoading ? "Carregando..." : "Carregar mais"}
            </button>
          </div>
        ) : null}
      </section>
    </div>
  );
}
